<h4>Internal Server Error</h4>
<ng-container *ngIf="error">
    <h5 class="text-danger">Error: {{error.message}}</h5>
    <p class="font-weight-bold">Note: If you are seeing this error then angular is not to blame!</p>
    <ol>
        <li>Open chrome dev tools and check the failling networking request in the network tab</li>
        <li>Examine the URL of the failling request</li>
        <li>Reproduce the error in postman - If you can reproduce the error than angular is not to blame</li>
    </ol>
    <p class="font-weight-bold">Following is the stack trace - check the first 2 lines this tells you exacetly whic line of code caused the pgorgram</p>
    <code class="mt-5" styles="bakground-color: whitesome;">{{error.details}}</code>
</ng-container>